export default __webpack_public_path__ + "6751d451ac79dbba27c768f21ce76b40.svg";